// extracted by mini-css-extract-plugin
module.exports = {"stave":"styles-module__stave___3gkZ8"};